__turbopack_context__.v({
  "CoverSelectionBtnWrapper": "vK6dzG_CoverSelectionBtnWrapper",
  "focus_class": "vK6dzG_focus_class",
  "icon_btn_secondary": "vK6dzG_icon_btn_secondary",
  "icon_btn_secondary_dark": "vK6dzG_icon_btn_secondary_dark",
  "label_button_active": "vK6dzG_label_button_active",
  "left_Icon_margin": "vK6dzG_left_Icon_margin",
  "primary": "vK6dzG_primary",
  "primary_left_icon": "vK6dzG_primary_left_icon",
  "right_Icon_margin": "vK6dzG_right_Icon_margin",
  "secondary": "vK6dzG_secondary",
  "secondary_left_icon": "vK6dzG_secondary_left_icon",
  "tertiary_dark": "vK6dzG_tertiary_dark",
  "tertiary_light": "vK6dzG_tertiary_light",
  "tertiary_light_error": "vK6dzG_tertiary_light_error",
  "tertiary_light_icon": "vK6dzG_tertiary_light_icon",
});
